import Alert from "@material-ui/lab/Alert/Alert";
import { ReactComponent as IconError } from "../../../../images/icon-error.svg";
import classes from "../../../common/alert/alert.module.scss";
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { ReactComponent as IconClose } from "../../../../images/icon-close.svg";
import { PatientMedsExpireDetails } from '../../../../services/medicationmanagement/patientApi/models/PatientMedsExpireDetails';
import { ReactComponent as IconWarning } from "../../../../images/icon-warning.svg";
import { NonMandatory } from "../../../common";
import { DateFormatter } from "../../../common/date-display/DateDisplay";

const useStyles = makeStyles({
    title:{
        fontSize:"14px",
        fontWeight:"bold"
    },
    dateText:{
        fontSize:"12px",
        fontWeight:"bold"  
    },
    list:{
        margin:0,
        paddingTop: "0px",
        paddingLeft: "30px",
        fontFamily: "Source Sans Pro",
       
    },
    listItem: {
        paddingTop: "0px",
        paddingLeft: "0px",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px"
    }
})

interface IResidentMedicationsExpiryDisplay{
    expiredMeds: NonMandatory<PatientMedsExpireDetails[]>,
    expiringMeds: NonMandatory<PatientMedsExpireDetails[]>,
    onClose: () => void
}

export const MedicationExpiryDisplay = (props :IResidentMedicationsExpiryDisplay) => {

    let expiredMeds = props.expiredMeds;
    let expiringMeds = props.expiringMeds;
    
    return (
       <Box>
        {expiredMeds && expiredMeds.length > 0 && <ExpiredMedications data = {expiredMeds} onClose = {()=>props.onClose()}></ExpiredMedications> }
        {expiringMeds && expiringMeds.length > 0  &&  <ExpiringMedications  data = {expiringMeds} onClose = {()=>props.onClose()}></ExpiringMedications>}
      </Box>
    )
}

 const ExpiredMedications = (props : {data:PatientMedsExpireDetails[] ,onClose : ()=>void }) => {
    let expiredClasses = useStyles();
    
    return (
        <Alert
         className={classes.errorAlert}
         style={{ alignItems: "start", marginBottom: 10}}
         icon={<IconError  className={classes.errorIcon}/>}
         variant="outlined"
         action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                props.onClose();
              }}
            >
              <IconClose  className={classes.errorclose}/>
            </IconButton>
          }
        >
           <div className={expiredClasses.title}> {props.data.length} {props.data.length > 1 ?  " medications" : " medication"}  expired</div>
           <ul className={expiredClasses.list}>
            { props.data.map( x => {
                return <li key = {x.medicationId} className={expiredClasses.listItem}>
                     {x.name} | 
                    <span className={expiredClasses.dateText}> End Date: </span>
                    {DateFormatter("DD-MMM-yyyy", x.expireyDate.toString())}
                </li>
            })}
           </ul>
        </Alert>
    );
};

 const ExpiringMedications = (props : {data:PatientMedsExpireDetails[], onClose : ()=>void }) => {
    let expiredClasses = useStyles();
    
    return (
        <Alert
            className={classes.warningAlert}
            style={{ alignItems: "start"}}
            icon={<IconWarning   className={classes.warningIcon}/>}
            variant="outlined"
            action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    props.onClose();
                  }}
                >
                  <IconClose  className={classes.warningclose}/>
                </IconButton>
              }
            >
             <div className={expiredClasses.title}> {props.data.length} {props.data.length > 1 ?  " medications " : " medication "}  expiring</div>
            <ul className={expiredClasses.list}>
                { props.data.map( x => {
                    return <li key = {x.medicationId} className={expiredClasses.listItem}> {x.name} |
                        <span className={expiredClasses.dateText}> End Date: </span>
                        {DateFormatter("DD-MMM-yyyy", x.expireyDate.toString())}
                    </li>
                })}
            </ul>
        </Alert>
    );
};
